{
  "build_id": "a4e42e5e19",
  "build_timestamp": 1788434945000,
  "environment": "prod",
  "version": "release-bw-tf-4.1.4"
}
